export const FACEBOOK = 'facebook';
export const FIREBASE = 'firebase';
export const LOCALHOST = 'localhost';